import { Injectable } from '@angular/core';

import { has, forEach } from 'lodash';

import { AUTH_PATHS } from './auth/auth';
import { COMPANIES_PATHS } from './companies/companies';
import { MAIN_PATHS } from './main/main';
import { NOTIFICATIONS_PATHS } from './notifications/notifications';
import { SECTORS_PATHS } from './sectors/sectors';
import { TICKETS_PATHS } from './tickets/tickets';
import { USER_PATHS } from './user/user';
import { USERS_PATHS } from './users/users';
import { WORK_SHIFT_PATHS } from './work-shift/work-shift';
import { WORK_SHIFTS_PATHS } from './work-shifts/work-shifts';
import { APP_SETTINGS_PATHS } from './app-settings/app-settings';

@Injectable({
  providedIn: 'root',
})
export class PagesMapService {
  PagesMap = {};

  constructor() {
    const pagesPaths = [
      AUTH_PATHS,
      COMPANIES_PATHS,
      MAIN_PATHS,
      NOTIFICATIONS_PATHS,
      SECTORS_PATHS,
      TICKETS_PATHS,
      USER_PATHS,
      USERS_PATHS,
      WORK_SHIFT_PATHS,
      WORK_SHIFTS_PATHS,
      APP_SETTINGS_PATHS,
    ];

    forEach(pagesPaths, (page) => {
      forEach(page, (path, key) => {
        this.PagesMap[key] = path;
      });
    });
  }

  makeRoutePath(routeName, positionParams, queryParams) {
    let path = ['/'];
    let countPositionParams = 0;
    let existsPositionParams = 0;

    forEach(positionParams, (value, key) => {
      countPositionParams++;

      if (value !== null) {
        existsPositionParams++;
      }
    });

    if (this.PagesMap[routeName] && countPositionParams === existsPositionParams) {
      let routeArr = this.PagesMap[routeName].split('/');

      forEach(routeArr, (part) => {
        if (part.charAt(0) === ':') {
          let paramName = part.slice(1);
          if (has(positionParams, paramName) && positionParams[paramName] !== null) {
            path.push(positionParams[paramName]);
          }
        } else {
          path.push(part);
        }
      });

      path.push(queryParams);
    }

    return path;
  }
}
